const genderList = [
  { name: 'sheHer', id: 'f' },
  { name: 'heHim', id: 'm' },
  { name: 'theyThem', id: 'x' },
  { name: 'preferNotToSay', id: '' },
];

export default genderList;
